export const ledgerTyeOptions = [
  { value: "revenue", label: "Revenue" },
  { value: "expense", label: "Expense" },
  { value: "asset", label: "Asset" },
  { value: "liability", label: "Liability" },
  { value: "bank", label: "Bank" },
]